import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ProcessEnum, SharedHttpService } from './shared-http.service';
import { CaseType } from '../model/caseType';
import { UserService } from './user.service';
import { Role } from './role.service';

// Menu
export interface Menu {
    headTitle1?: string,
    headTitle2?: string,
    path?: string;
    title?: string;
    icon?: string;
    type?: string;
    badgeType?: string;
    badgeValue?: string;
    active?: boolean;
    bookmark?: boolean;
    children?: Menu[];
    child?: [];

}

@Injectable({
    providedIn: 'root'
})

export class NavService implements OnDestroy {

    private unsubscriber: Subject<any> = new Subject();
    public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

    // Search Box
    public search: boolean = false;

    // Language
    public language: boolean = false;

    // Mega Menu
    public megaMenu: boolean = false;
    public levelMenu: boolean = false;
    public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

    // For Horizontal Layout Mobile
    public horizontal: boolean = window.innerWidth < 991 ? false : true;

    // Collapse Sidebar
    public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

    // Full screen
    public fullScreen: boolean = false;
    currentUserRole: any;
    CaseType:CaseType;
    public Process = ProcessEnum;

    constructor(private router: Router, shared: SharedHttpService, public userService : UserService ) {
        this.currentUserRole= this.userService.getCurrentUserRole();
        console.log('current user role', this.currentUserRole)
        if(this.currentUserRole){
            this.CaseType=this.userService.getCaseType(this.currentUserRole.caseTypeId)
        }
        let user = JSON.parse(localStorage.getItem("user"));
        this.setScreenWidth(window.innerWidth);
        fromEvent(window, 'resize').pipe(
            debounceTime(1000),
            takeUntil(this.unsubscriber)
        ).subscribe((evt: any) => {
            this.setScreenWidth(evt.target.innerWidth);
            if (evt.target.innerWidth < 991) {
                this.collapseSidebar = true;
                this.megaMenu = false;
                this.levelMenu = false;
            }
            if (evt.target.innerWidth < 1199) {
                this.megaMenuColapse = true;
            }
        });
        if (window.innerWidth < 991) { // Detect Route change sidebar close
            this.router.events.subscribe(event => {
                this.collapseSidebar = true;
                this.megaMenu = false;
                this.levelMenu = false;
            });
        }

        /*this.MENUITEMS.push({ title: 'Home', icon: 'home', path: '/CasesList', type: 'link' });*/
        function objectReturn(obj:any) {
     let  arrayOf : Menu[]=[];

            obj.forEach(a => {
                arrayOf.push({ title: a.typeName, icon: 'file-text', path: `boxes/refresh/${a.eCaseTypeId}/${a.id}`, type: 'link' });
            });
            return  arrayOf;
        }

        if (user.roleTypeId == 1 && user.caseTypes != null && user.caseTypes.length > 0) {
            if (user.caseTypes.length == 1) {
                user.caseTypes.forEach(a => {
                    this.MENUITEMS.push({ title: a.typeName, icon: 'file-text', path: `boxes/refresh/${a.eCaseTypeId}/${a.id}`, type: 'link' });
                });
            }
            if (user.caseTypes.length > 1) {
                this.MENUITEMS.push({
                    title: 'typeOfCase', icon: 'list', type: 'sub', badgeType: 'success', active: true, children: 
                        objectReturn(user.caseTypes)
                    
                });
            }
        }




        //مخالفات الادارة
        if (
            shared.hasPermission('P401') ||
            shared.hasPermission('P402') ||
            shared.hasPermission('P403') ||
            shared.hasPermission('P404')
        ) {
            this.MENUITEMS.push({ title: 'Home', icon: 'home', path: '/', type: 'link' });
            // this.MENUITEMS.push({ title: 'CreateCase', icon: 'file-plus', path: '/case/add-case', type: 'link' });
            this.MENUITEMS.push({ title: 'DraftCase', icon: 'file-text', path: '/violation/boxes', type: 'link' });
            this.MENUITEMS.push({ title: 'Inbox', icon: 'mail', path: '/violation/boxes/inbox', type: 'link' });
            this.MENUITEMS.push({ title: 'Sent', icon: 'share', path: '/violation/boxes/outbox', type: 'link' });
            this.MENUITEMS.push({ title: 'Finished', icon: 'check-circle', path: '/violation/boxes/finished', type: 'link' });
            this.MENUITEMS.push({ title: 'Saved', icon: 'save', path: '/violation/boxes/saved', type: 'link' });
            this.MENUITEMS.push({ title: 'Deleted', icon: 'trash', path: '/violation/boxes/deleted', type: 'link' });



        }
        // مخالفات اللجنة
        if (
            shared.hasPermission('P501') ||
            shared.hasPermission('P502') ||
            shared.hasPermission('P503') ||
            shared.hasPermission('P504')
        ) {


            this.MENUITEMS.push({ title: 'Home', icon: 'home', path: '/', type: 'link' });

            this.MENUITEMS.push({ title: 'Inbox', icon: 'mail', path: '/violation/boxes/inbox', type: 'link' });
            this.MENUITEMS.push({ title: 'Sent', icon: 'share', path: '/violation/boxes/outbox', type: 'link' });
            this.MENUITEMS.push({ title: 'Finished', icon: 'check-circle', path: '/violation/boxes/finished', type: 'link' });
            this.MENUITEMS.push({ title: 'Saved', icon: 'save', path: '/violation/boxes/saved', type: 'link' });



        }
        if (user.roleId == 1) {    //مدير النظام
            this.MENUITEMS.push({
                title: 'AccountStatements', icon: 'align-justify', type: 'sub', badgeType: 'success', active: true, children: [

                    { path: '/AccountStatements/needapproval', title: 'NeedApproval', type: 'link' }
                ]
            });
            this.MENUITEMS.push({
                title: 'additionRequest', icon: 'list', type: 'sub', badgeType: 'success', active: true, children: [

                    { path: '/additionRequest/needapproval', title: 'NeedApproval', type: 'link' }
                ]
            });
        }
        if (shared.hasPermission('P007') || shared.hasPermission('P008')) {
            this.MENUITEMS.push({
                title: 'AccountStatements', icon: 'align-justify', type: 'sub', badgeType: 'success', active: true, children: [

                    { path: '/AccountStatements/needapproval', title: 'جميع الطلبات', type: 'link' }
                ]
            });
            this.MENUITEMS.push({
                title: 'additionRequest', icon: 'list', type: 'sub', badgeType: 'success', active: true, children: [

                    { path: '/additionRequest/needapproval', title: 'جميع الطلبات', type: 'link' }
                ]
            });
        }
        if (shared.hasPermission('P002') && !shared.hasPermission('P003')) {   // موظف 

            this.MENUITEMS.push({
                title: 'AccountStatements', icon: 'align-justify', type: 'sub', badgeType: 'success', active: true, children: [
                    { path: '/AccountStatements/myrequests', title: 'MyRequests', type: 'link' },
                    // { path: '/AccountStatements/needapproval', title: 'NeedApproval', type: 'link' }
                ]
            });


            this.MENUITEMS.push({
                title: 'additionRequest', icon: 'list', type: 'sub', badgeType: 'success', active: true, children: [
                    { path: '/additionRequest/myrequests', title: 'MyRequests', type: 'link' },
                    // { path: '/additionRequest/needapproval', title: 'NeedApproval', type: 'link' }
                ]
            });
        }
        if (
            shared.hasPermission('P003'))    //مدير ادارة له صلاحيات موافقات
        {
            this.MENUITEMS.push({
                title: 'AccountStatements', icon: 'align-justify', type: 'sub', badgeType: 'success', active: true, children: [
                    { path: '/AccountStatements/myrequests', title: 'MyRequests', type: 'link' },
                    { path: '/AccountStatements/needapproval', title: 'NeedApproval', type: 'link' }
                ]
            });

            this.MENUITEMS.push({
                title: 'additionRequest', icon: 'list', type: 'sub', badgeType: 'success', active: true, children: [
                    { path: '/additionRequest/myrequests', title: 'MyRequests', type: 'link' },
                    { path: '/additionRequest/needapproval', title: 'NeedApproval', type: 'link' }
                ]
            });
        }
        if (shared.hasPermission('P003')) {
            this.MENUITEMS.push({ title: 'CaseWithoutOwner', icon: 'file-text', path: 'boxes/CaseWithoutowner', type: 'link' });
        }

        if (shared.hasPermission('P607')) {
            this.MENUITEMS.push({ title: 'allAdjudications', icon: 'file-text', path: '/adjudication/list/getAdjudications', type: 'link' });
        }
        if (shared.hasPermission('P601')) {
            this.MENUITEMS.push({ title: 'myAdjudications', icon: 'file-text', path: '/adjudication/list/getMyAdjudications', type: 'link' });
        }
        if (shared.hasPermission('P605')) {
            this.MENUITEMS.push({ title: 'adjudicationsNeedActions', icon: 'file-text', path: '/adjudication/list/getAdjudicationsNeedActions', type: 'link' });
        }
        if (shared.hasPermission('P603')) {
            this.MENUITEMS.push({ title: 'adjudicationsNeedAcquittal', icon: 'file-text', path: '/adjudication/list/getAdjudicationsNeedAcquittal', type: 'link' });
        }
        if (shared.hasPermission('P602')) {
            this.MENUITEMS.push({ title: 'checkerAdjudications', icon: 'file-text', path: '/adjudication/list/getCheckerAdjudications', type: 'link' });
        }
        if (shared.hasPermission('P606')) {
            this.MENUITEMS.push({ title: 'checkerAdjudicationsActions', icon: 'file-text', path: '/adjudication/list/getCheckerAdjudicationsActions', type: 'link' });
        }
        if (shared.hasPermission('P604')) {
            this.MENUITEMS.push({ title: 'checkerAcquittal', icon: 'file-text', path: '/adjudication/list/getCheckerAcquittal', type: 'link' });
        }
        if (shared.hasPermission('P701')) {
            this.MENUITEMS.push({
                title: 'criminalRecord', icon: 'edit', type: 'sub', badgeType: 'success', active: true, children: [
                    { path: '/criminalRecords/persons/null', title: 'Persons', type: 'link' },
                    { path: '/criminalRecords/companies/null', title: 'Companies', type: 'link' }
                ]
            });
        }



        this.MENUITEMS.push();
        this.MENUITEMS.push();
        if(this.currentUserRole && ((this.currentUserRole.roleId === Role.Officer && this.CaseType.processId === this.Process.Company ) || (this.currentUserRole.roleId === Role.Study && this.CaseType.processId === this.Process.Consumer ))){
            this.MENUITEMS.push({ title: 'Settings', icon: 'settings', path: '/settings', type: 'sub', badgeType: 'success', active: true, children: [] });
            this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                { path: '/settings/questions', title: 'Questions', type: 'link' }
            );
        }
        if (shared.hasPermission('P901') ||
            shared.hasPermission('P902') ||
            shared.hasPermission('P903') ||
            shared.hasPermission('P904') ) {

            this.MENUITEMS.push({ title: 'Settings', icon: 'settings', path: '/settings', type: 'sub', badgeType: 'success', active: true, children: [] });


            if (shared.hasPermission('P901')) {
                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/users', title: 'Users', type: 'link' }
                );
            }
            if (shared.hasPermission('P902')) {
                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/roles', title: 'Roles', type: 'link' }
                );
            }
            if (shared.hasPermission('P903')) {
                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/evidence-type', title: 'EvidenceType', type: 'link' }
                );
            }
            if (shared.hasPermission('P904')) {
                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/violation-type', title: 'ViolationType', type: 'link' }
                );
            }
            if (shared.hasPermission('P905')) {

                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/report-types', title: 'ReportTypes', type: 'link' }
                );
            }
            if (shared.CurrentUser.userName == 'admin') {

                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/legal-articles', title: 'LegalArticles', type: 'link' },
                );
                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/facts', title: 'Facts', type: 'link' },
                );
                this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/reasons', title: 'Reasons', type: 'link' },
                ); this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                    { path: '/settings/penalties', title: 'Penalties', type: 'link' },
                );
            }
            this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                { path: '/settings/case-types', title: 'CaseTypes', type: 'link' }
            );
            this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                { path: '/settings/organization', title: 'Organization', type: 'link' }
            );
            this.MENUITEMS.filter(a => a.title == "Settings")[0].children.push(
                { path: '/settings/branch', title: 'branchList', type: 'link' }
            );
        }

        if (shared.hasCasePermission('P002', 4) ||
            shared.hasCasePermission('P003', 4) ||
            shared.hasCasePermission('P007', 4) || shared.hasCasePermission('P008', 4)) {
            this.MENUITEMS.push({ title: 'InspectionOrder', icon: 'box', path: 'inspection/list', type: 'link' });
        }







        // if (shared.CurrentRoleId == 4 || shared.CurrentRoleId == 5 || shared.CurrentRoleId == 6 || shared.CurrentRoleId == 7) {
        // 	this.MENUITEMS.push({
        // 		title: 'Reports', icon: 'bar-chart-2', type: 'sub', badgeType: 'success', active: true, children: [ 

        // 			{ path: '/reports', title: 'CommitteesReport', type: 'link' }, 
        // 			{ path: '/reports/CommitteeStatusReport', title: 'CommitteeStatusReport', type: 'link' }, 
        // 			{ path: '/reports/PerformanceReport', title: 'PerformanceReport', type: 'link' },

        // 		]
        // 	});
        // }
        // if (shared.CurrentRoleId == 7 || shared.CurrentRoleId == 4) {
        // 	this.MENUITEMS.push({
        // 	title: 'settings', icon: 'settings', path: '/settings', type: 'sub', badgeType: 'success', active: true, children: [

        // 		{ path: '/settings/penalties', title: 'Penalties', type: 'link' }


        // 	]
        // });
        // }


        // if (shared.CurrentRoleId == 2 || shared.CurrentRoleId == 3) {
        // 	this.MENUITEMS.push({
        // 		title: 'Reports', icon: 'bar-chart-2', type: 'sub', badgeType: 'success', active: true, children: [



        // 			{ path: '/reports/OrganizationsReport', title: 'organizationsReport', type: 'link' }, 
        // 			{ path: '/reports/OrganizationsStatusReport', title: 'CommitteeStatusReport', type: 'link' },
        // 			{ path: '/reports/PerformanceReport', title: 'PerformanceReport', type: 'link' },

        // 		]
        // 	});
        // }

        // if (shared.CurrentRoleId == 3) {
        // 	this.MENUITEMS.push({
        // 	title: 'settings', icon: 'settings', path: '/settings', type: 'sub', badgeType: 'success', active: true, children: [


        // 		{ path: '/settings/violations', title: 'Violations', type: 'link' },




        // 	]
        // });
        // }





    }

    ngOnDestroy() {
        // this.unsubscriber.next();
        this.unsubscriber.complete();
    }


    private setScreenWidth(width: number): void {
        this.screenWidth.next(width);
    }



    //let settings=


    MENUITEMS: Menu[] = [



    ];

    MEGAMENUITEMS: Menu[] = [

    ];

    LEVELMENUITEMS: Menu[] = [

    ];

    // Array
    items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
    megaItems = new BehaviorSubject<Menu[]>(this.MEGAMENUITEMS);
    levelmenuitems = new BehaviorSubject<Menu[]>(this.LEVELMENUITEMS);

}
